// hooks/useChangelog.ts
/**
 * CHANGELOG.md, parsed. Fetched by a dynamic `?raw` import, so the file is a chunk of its own,
 * loaded only when the badge's popover or the /changelog page first asks; production shows
 * neither, so never loads it.
 */
import { useEffect, useState } from 'react';
import { type Changelog, parseChangelog } from '@/utils/changelog';

/** The parsed changelog, or null until it has loaded (and if it fails to) */
export const useChangelog = (): Changelog | null => {
    const [log, setLog] = useState<Changelog | null>(null);
    useEffect(() => {
        let live = true;
        import('../../CHANGELOG.md?raw')
            .then((m) => live && setLog(parseChangelog(m.default)))
            .catch(() => live && setLog(null));
        return () => {
            live = false;
        };
    }, []);
    return log;
};
